<template>
  <div class="home">
    <div class="banner-wrap">
      <el-carousel :interval="5000" arrow="never" :loop="true" height="440px" trigger="click">
        <el-carousel-item v-for="item in bannerList" :key="item.src">
          <img :src="item.src" alt="">
          <h3>{{ item.title }}</h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="team-wrap">
      <main-title title="团队简介" color="#ec1e24"></main-title>
      <div class="team-show">
        <i class="symbol-icon" style="backgroundImage: url(images/icons/symbolicon.png)"></i>
        <div class="show-pic">
          <img src="images/team-1.png" alt="">
        </div>
        <p class="show-text">槃灵科技团队成员主要由专业计算机技术人员组成，拥有众多的 IT 互联网解决方案与实践经验，我们秉持数字工匠精神，希望用科技创新提升服务品质。</p>
      </div>
    </div>
    <div class="business-wrap">
      <img src="images/business-bg.png" alt="" class="business-bg" />
      <div class="business-con">
        <main-title title="业务介绍" color="#fff" titleColor="#fff"></main-title>
        <p class="business-text">我们愿用真诚的态度与先进技术为企业解决互联网岗位空缺，提供满意的IT服务。</p>
        <div class="busi-wrap">
          <div class="busi-list">
            <li class="busi-item" v-for="item in busiLinkList" :key="item.href" :style="{backgroundImage: 'url(' + item.url + ')'}">
              <h2>{{ item.title }}<br>{{ item.titleEG }}</h2>
              <router-link :to="item.href" class="busi-link"></router-link>
            </li>
          </div>
          <!-- <img src="images/serverBanner1.png" alt="" class="server-banner" style="width: 100%;object-fit: contain;"> -->
          <!-- <div class="busi" v-for="item in busiList" :key="item.id">
            <div class="title-icon">
              <img :src="item.src" alt="" :style="item.style">
            </div>
            <div class="busi-title-wrap">
              <div class="title-con">
                <h3>{{item.title}}</h3>
                <p>{{item.titleEg}}</p>
              </div>
            </div>
            <ul class="busi-list">
              <li class="busi-item" v-for="li in item.list" :key="li"> <span>{{li}}</span> </li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>
    <div class="service-wrap">
      <main-title title="服务理念" color="#ec1e24"></main-title>
      <ul class="service-list">
        <li class="service-item" v-for="item in serviceList" :key="item.id">
          <div class="serv-show">
            <i class="serv-icon" :style="item.icon"></i>
            <p class="serv-title">{{ item.servTitle }}</p>
          </div>
          <div class="serv-hover">
            <p class="serv-title">{{ item.servTitle }}</p>
            <p class="serv-text">{{ item.servText }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mainTitle from '@/components/title'
export default {
  name: 'Home',
  components: {
    mainTitle
  },
  data() {
    return {
      bannerList: [
        {
          src: './images/banner1.png',
          title: '提供全面IT互联网开发建设解决方案'
        },
        {
          src: './images/banner2.png',
          title: '提供全面IT互联网开发建设解决方案'
        }
      ],
      busiList: [
        {
          id: 1,
          title: '品牌设计',
          titleEg: 'Brand design',
          src: './images/icons/brand.png',
          list: [
            '品牌设计',
            'logo设计',
            '企业VI设计',
            '产品设计',
            '宣传设计'
          ],
          style: {
            height: '28px',
            marginTop: '10px'
          }
        },
        {
          id: 2,
          title: 'IT设计',
          titleEg: 'IT design',
          src: './images/icons/it.png',
          list: [
            '官网设计',
            '电商设计',
            'App设计',
            '小程序设计',
            '移动互联网设计'
          ],
          style: {
            height: '21px',
            marginTop: '13px'
          }
        },
        {
          id: 3,
          title: '软件开发',
          titleEg: 'Software develop',
          src: './images/icons/application.png',
          list: [
            'PC端网页开发',
            '网页应用开发',
            '移动端应用开发',
            'App开发',
            '小程序开发'
          ],
          style: {
            height: '28px',
            marginTop: '10px'
          }
        },
      ],
      serviceList: [
        {
          id: 1,
          bgi: 'url(./images/service1.png)',
          icon: {
            backgroundImage: 'url(./images/icons/servicon1.png)',
            width: '42px',
            height: '48px'
          },
          servTitle: '客户至上',
          servText: '我们以礼相待，注重换位思考，想客户之所想，急客户之所急，用心服务每一名惠顾我们的客户。'
        },
        {
          id: 2,
          bgi: 'url(./images/service2.png)',
          icon: {
            backgroundImage: 'url(./images/icons/servicon2.png)',
            width: '48px',
            height: '48px'
          },
          servTitle: '注重沟通',
          servText: '我们客服团队 24 小时一直都在服务状态，随时响应客户请求。'
        },
        {
          id: 3,
          bgi: 'url(./images/service3.png)',
          icon: {
            backgroundImage: 'url(./images/icons/servicon3.png)',
            width: '48px',
            height: '48px'
          },
          servTitle: '遵守时间',
          servText: '我们会制定可靠的项目计划，并确保在时间进度之内实现交付。'
        },
        {
          id: 4,
          bgi: 'url(./images/service4.png)',
          icon: {
            backgroundImage: 'url(./images/icons/servicon4.png)',
            width: '48px',
            height: '48px'
          },
          servTitle: '严控质量',
          servText: '我们一直都将项目质量作为首先的考虑，从不做“差不多”先生。。'
        },
        {
          id: 5,
          bgi: 'url(./images/service5.png)',
          icon: {
            backgroundImage: 'url(./images/icons/servicon5.png)',
            width: '48px',
            height: '48px'
          },
          servTitle: '感恩客户',
          servText: '对于历史客户，我们依然感激您的曾经惠顾，会提供尽力的支持。'
        },
      ],
      
      busiLinkList: [
        {
          href: '/ghidorah',
          title: '企业 VI 设计',
          titleEG: 'Enterprise VI Design',
          url: 'images/Ghi.png'
        },
        {
          href: '/phixsoul',
          title: '槃灵软件开发',
          titleEG: 'PHIXSOUL',
          url: 'images/phix.png'
        },
        {
          href: '/whxq',
          title: '文华星启IT学园',
          titleEG: 'WHXQCODE',
          url: 'images/whxq.png'
        },
        {
          href: '/ben',
          title: '棒小呆UI设计',
          titleEG: '笨笨学姐',
          url: 'images/ben.png'
        }
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  margin-top: 80px;
  padding-bottom: 80px;
}

.banner-wrap {
  img {
    width: 100%;
    height: 440px;
  }

  .el-carousel {
    width: 100%;
  }

  .el-carousel__item h3 {
    position: absolute;
    top: 30%;
    left: 6%;
    width: 570px;
    color: #fff;
    font-size: 48px;
  }
}

.team-wrap {
  width: 1200px;
  margin: auto;
  padding: 80px 0;

  .team-show {
    position: relative;
    height: 130px;
    margin-top: 120px;
    margin-bottom: 30px;
    background-image: linear-gradient(to bottom right, #F76F2D, #ec1e24);
    border-top-left-radius: 50px;
    border-bottom-right-radius: 50px;

    &::after {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      background-color: #fff;
      border-top-left-radius: 50px;
      border-bottom-right-radius: 50px;
    }

    &:hover {
      &:after {
        display: none;
      }

      .show-text {
        color: #fff;
      }
    }

    .symbol-icon {
      position: absolute;
      top: -60px;
      left: 40px;
      z-index: 90;
      display: inline-block;
      width: 63px;
      height: 41px;
    }

    .show-pic {
      display: inline-block;
      position: relative;
      left: 82px;
      top: -50px;
      z-index: 20;
      width: 224px;
      height: 224px;
      border: 4px solid #fff;
      background-image: linear-gradient(to bottom right, #F76F2D, #ec1e24);
      border-radius: 50%;
      text-align: center;

      img {
        width: 128px;
        margin-top: 50px;
      }
    }

    .show-text {
      display: inline-block;
      position: relative;
      top: -50px;
      left: 10%;
      z-index: 20;
      width: 65%;
      font-size: 24px;
    }
  }
}

.business-wrap {
  position: relative;
  padding-top: 42px;
  // margin-bottom: 75px;

  .business-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 320px;
  }

  .business-con {
    position: relative;
  }

  .business-text {
    margin-top: 18px;
    margin-bottom: 52px;
    color: #fff;
    text-align: center;
    font-size: 16px;
  }
}

.busi-wrap {
  position: relative;
  display: flex;
  width: 1200px;
  height: 376px;
  margin: auto;
  margin-bottom: 60px;
  justify-content: space-around;

  .busi-list {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .busi-item {
      position: relative;
      float: left;
      width: 25%;
      height: 100%;
      background-size: 100%;
      transition: all .3s linear;
      &:hover {
        transform: scale(1.1);
      }
      h2 {
        float: left;
        width: 100%;
        margin-top: 12%;
        text-align: center;
        color: transparent;
      }
    }

    .busi-link {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .busi {
    display: inline-block;
    position: relative;
    width: 30%;
    height: 100%;
    background: #fff;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.08);

    &:nth-child(1) {
      .busi-title-wrap {
        background: #ec1c24;
      }
    }

    &:nth-child(2) {
      .busi-title-wrap {
        background: #87c911;
      }
    }

    &:nth-child(3) {
      .busi-title-wrap {
        background: #419afd;
      }
    }
  }

  .busi-title-wrap {
    position: relative;
    height: 132px;
    padding-top: 27px;
    margin-bottom: 40px;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.08);
    clip-path: polygon(0% 0%, 0% 100%, 100% 70%, 100% 0%);

    .title-con {
      color: #fff;
      text-align: center;
      font-weight: 500;

      h3 {
        font-size: 24px;
      }

      p {
        font-size: 16px;
      }
    }
  }

  .title-icon {
    position: absolute;
    right: 18px;
    top: 72px;
    z-index: 20;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.13);
    text-align: center;

    img {
      width: 28px;
      height: 28px;
      margin-top: 10px;
    }
  }

  .busi-list {

    .busi-item {
      margin: 0 auto;
      margin-bottom: 24px;
      text-align: center;
    }

    .busi-item span {
      position: relative;
      font-size: 16px;

      &::before,
      &::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 42px;
        height: 1px;
      }

      &::before {
        left: -52px;
        background-image: linear-gradient(to right, rgba(200, 200, 200, 0), rgba(0, 0, 0, .2));
      }

      &::after {
        right: -52px;
        background-image: linear-gradient(to left, rgba(200, 200, 200, 0), rgba(0, 0, 0, .2));
      }
    }
  }
}

.service-list {
  display: flex;
  position: relative;
  width: 1200px;
  height: 278px;
  margin: auto;
  margin-top: 45px;
  justify-content: space-between;

  .service-item {
    width: 18%;
    height: 100%;
    background-color: #333;

    &:hover {

      .serv-show {
        display: none;
      }

      .serv-hover {
        display: block;
      }
    }
  }

  .serv-show {
    display: block;
    height: 80px;
    margin-top: 90px;
    text-align: center;

    .serv-icon {
      display: inline-block;
      width: 42px;
      height: 48px;
      margin-bottom: 22px;
      background-size: cover;
    }

    .serv-title {
      color: #fff;
      font-weight: 500;
      font-size: 24px;
    }
  }

  .serv-hover {
    display: none;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom right, #f8752e, #ec1c24);

    .serv-title {
      position: relative;
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-weight: 500;
      color: #fff;
      font-size: 24px;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 10%;
        right: 10%;
        border: 1px dashed #fff;
        opacity: .4;
      }
    }

    .serv-text {
      padding: 18px 30px;
      font-size: 16px;
      color: #fff;
      text-align: justify;
    }
  }
}
</style>
